import { Routes } from '@angular/router';
import {
  ApplicantDataComponentConfig,
  ApplicantDataSectionComponent
} from '../common/applicant-data-section/applicant-data-section.component';
import {
  ApplicationDataComponentConfig,
  ApplicationDataSectionComponent
} from '../common/application-data-section/application-data-section.component';
import {
  AgreementsDataComponentConfig,
  AgreementsDataSectionComponent
} from '../common/agreements-data-section/agreements-data-section.component';
import {
  AttachmentDataComponentConfig,
  AttachmentsDataSectionComponent
} from '../common/attachments-data-section/attachments-data-section.component';
import {
  TrafficOrganizationProjectSectionComponent
} from './sections/traffic-organization-project-section/traffic-organization-project-section.component';
import {
  LocalisationDataComponentConfig, LocalisationDataSectionComponent
} from '../common/localisation-data-section/localisation-data-section.component';
import {
  ContractorDataComponentConfig,
  ContractorDataSectionComponent
} from "../common/contractor-data-section/contractor-data-section.component";

export const stages: string[] = [
  'Wnioskodawca',
  'Dane wniosku',
  'Projekt organizacji ruchu',
  'Inwestor',
  'Lokalizacja',
  'Zgody',
  'Załączniki'
];

export const applicantDataSectionConfig: ApplicantDataComponentConfig = {
  stages
};

export const applicationDataSectionConfig: ApplicationDataComponentConfig = {
  stages,
  successUrl: '../projekt-organizacji-ruchu',
  cancelUrl: '../wnioskodawca'
};

export const contractorDataSectionConfig: ContractorDataComponentConfig = {
  stages,
  cancelUrl: '../projekt-organizacji-ruchu',
  successUrl: '../lokalizacja',
  customTitles: {
    sectionTitle: 'Inwestor',
    dataSameAsApplicantLabels: {
      rejectLabel: 'Chcę wprowadzić dane inwestora',
      acceptLabel: 'Dane inwestora są takie same jak dane wnioskodawcy'
    },
    cardTitle: 'Dodanie inwestora',
    addBtnTitle: 'Dodaj inwestora',
    addBtn2Title: 'Dodaj kolejnego inwestora',
    noDataInfo: 'Brak dodanych inwestorów!',
    tag: 'investor'
  }
};

export const localisationDataSectionConfig: LocalisationDataComponentConfig = {
  stages,
  addRoadCategoryControl: true,
  cancelUrl: '../inwestor',
  successUrl: '../zgody'
};

export const agreementsDataSectionConfig: AgreementsDataComponentConfig = {
  stages,
  cancelUrl: '../lokalizacja',
  successUrl: '../zalaczniki'
};

export const attachmentDataSectionConfig: AttachmentDataComponentConfig = {
  stages,
  cancelUrl: '../zgody'
};

export const opinionOnTheProjectOfTrafficOrgRoutes: Routes = [
  {
    component: ApplicantDataSectionComponent,
    path: 'wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicantDataSectionComponent,
    path: ':appId/wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicationDataSectionComponent,
    path: ':appId/dane-wniosku',
    data: applicationDataSectionConfig
  },
  {
    component: TrafficOrganizationProjectSectionComponent,
    path: ':appId/projekt-organizacji-ruchu'
  },
  {
    component: ContractorDataSectionComponent,
    path: ':appId/inwestor',
    data: contractorDataSectionConfig
  },
  {
    component: LocalisationDataSectionComponent,
    path: ':appId/lokalizacja',
    data: localisationDataSectionConfig
  },
  {
    component: AgreementsDataSectionComponent,
    path: ':appId/zgody',
    data: agreementsDataSectionConfig
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  { path: '', redirectTo: 'wnioskodawca', pathMatch: 'prefix' }
];
